<template>
  <div>
    <div class="appointment-record-wrapper">
      <div
        class="header"
        @click="showAppointmentRecord = !showAppointmentRecord"
      >
        <p class="title">บันทึกการนัดบริการ</p>
        <div v-if="isShowAppointmentRecord" class="ms-2 arrow down"></div>
        <div v-if="!isShowAppointmentRecord" class="ms-2 arrow up"></div>
      </div>
      <div v-if="isShowAppointmentRecord" class="content">
        <div v-if="activeAppointmentNotice" class="collapsible active">
          <div
            class="arrow-wrapper"
            @click="handleShowActionNoteDetail(activeAppointmentNotice)"
          >
            <div class="status">
              <p :class="activeAppointmentNotice.statusClassList">
                {{ activeAppointmentNotice.status }}
              </p>
            </div>
            <div
              v-if="
                activeAppointmentNotice.isClickActiveAppointment &&
                  activeAppointmentNotice.actionNotes
              "
              class="ms-2 arrow down"
            ></div>
            <div
              v-else-if="activeAppointmentNotice.actionNotes"
              class="ms-2 arrow up"
            ></div>
          </div>
          <div class="detail mb-1">
            <p class="appointment-date">
              {{ activeAppointmentNotice.createdAt }}
            </p>
            <p>- {{ activeAppointmentNotice.actionName }}</p>
          </div>
          <div
            v-if="
              activeAppointmentNotice.isClickActiveAppointment &&
                activeAppointmentNotice.actionNotes
            "
            class="mb-1"
          >
            <div
              v-for="actionNote in activeAppointmentNotice.actionNotes"
              :key="actionNote.id"
            >
              <div class="detail mb-1">
                <p class="appointment-date">{{ actionNote.createdAt }}</p>
                <p>{{ `- ${actionNote.adminName} : "${actionNote.note}"` }}</p>
              </div>
            </div>
          </div>
          <label class="detail" for="note">เพิ่มเติม</label>
          <div class="input-note">
            <input
              id="note"
              v-model="textNote"
              type="text"
              class="form-control"
              style="flex-grow: 1; height: 44px;"
              name="note"
              placeholder="ระบุข้อความ"
              @keyup.enter="handleEnterToAddActionNote"
            />
            <sc-button
              variant="secondary"
              style="height: 44px;"
              @click="handleEnterToAddActionNote"
              >บันทึก</sc-button
            >
          </div>
        </div>
        <div v-if="inActiveAppointmentNotices">
          <div
            v-for="(appointmentNotice, index) in inActiveAppointmentNotices"
            :key="index"
            :class="
              index === inActiveAppointmentNotices.length - 1
                ? 'collapsible in-active'
                : 'collapsible collapsible-border in-active'
            "
          >
            <div>
              <div
                class="arrow-wrapper"
                @click="handleShowActionNoteDetail(appointmentNotice)"
              >
                <div class="status">
                  <p :class="appointmentNotice.statusClassList">
                    {{ appointmentNotice.status }}
                  </p>
                </div>
                <div
                  v-if="
                    appointmentNotice.isClickActiveAppointment &&
                      appointmentNotice.actionNotes
                  "
                  class="ms-2 arrow down"
                ></div>
                <div
                  v-else-if="appointmentNotice.actionNotes"
                  class="ms-2 arrow up"
                ></div>
              </div>
              <div class="detail">
                <p class="appointment-date">
                  {{ appointmentNotice.createdAt }}
                </p>
                <p>- {{ appointmentNotice.actionName }}</p>
              </div>
              <div
                v-if="
                  appointmentNotice.isClickActiveAppointment &&
                    appointmentNotice.actionNotes
                "
              >
                <div
                  v-for="actionNote in appointmentNotice.actionNotes"
                  :key="actionNote.id"
                  class="detail"
                >
                  <p class="appointment-date">
                    {{ actionNote.createdAt }}
                  </p>
                  <p>
                    {{ `- ${actionNote.adminName} : "${actionNote.note}"` }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="appointmentsCanceled" class="appointment-record-wrapper mt-3">
      <div
        class="header"
        @click="showCanceledAppointmentRecord = !showCanceledAppointmentRecord"
      >
        <p class="title">นัดหมายที่ยกเลิก</p>
        <div
          v-if="isShowCanceledAppointmentRecord"
          class="ms-2 arrow down"
        ></div>
        <div
          v-if="!isShowCanceledAppointmentRecord"
          class="ms-2 arrow up"
        ></div>
      </div>
      <div v-if="isShowCanceledAppointmentRecord" class="content">
        <div
          v-for="(appointmentCanceled, index) in appointmentsCanceled"
          :key="appointmentCanceled.id"
          :class="
            index === appointmentsCanceled.length - 1
              ? 'detail canceled'
              : 'detail canceled collapsible-border'
          "
        >
          <div
            class="canceled-detail arrow-wrapper"
            @click="handleOpenTapCanceled(appointmentCanceled)"
          >
            <p>{{ `ยกเลิกครั้งที่ ${appointmentCanceled.no}` }}</p>
            <div
              v-if="appointmentCanceled.isOpenTab"
              class="ms-2 arrow down"
            ></div>
            <div v-else class="ms-2 arrow up"></div>
          </div>
          <div v-if="appointmentCanceled.isOpenTab">
            <div
              v-for="(appointmentNoticeCanceled,
              canceledIndex) in appointmentCanceled.appointmentNotices"
              :key="canceledIndex"
            >
              <div class="mt-2">
                <div
                  class="arrow-wrapper"
                  @click="
                    handleShowActionNoteAppointmentCanceledDetail(
                      appointmentCanceled,
                      appointmentNoticeCanceled
                    )
                  "
                >
                  <div class="status">
                    <p :class="appointmentNoticeCanceled.statusClassList">
                      {{ appointmentNoticeCanceled.status }}
                    </p>
                  </div>
                  <div
                    v-if="
                      appointmentNoticeCanceled.isClickActiveAppointment &&
                        appointmentNoticeCanceled.actionNotes
                    "
                    class="ms-2 arrow down"
                  ></div>
                  <div
                    v-else-if="appointmentNoticeCanceled.actionNotes"
                    class="ms-2 arrow up"
                  ></div>
                </div>
                <div class="detail mb-1">
                  <p class="appointment-date">
                    {{ appointmentNoticeCanceled.createdAt }}
                  </p>
                  <p>- {{ appointmentNoticeCanceled.actionName }}</p>
                </div>
                <div
                  v-if="
                    appointmentNoticeCanceled.isClickActiveAppointment &&
                      appointmentNoticeCanceled.actionNotes
                  "
                >
                  <div
                    v-for="actionNote in appointmentNoticeCanceled.actionNotes"
                    :key="actionNote.id"
                    class="detail"
                  >
                    <p class="appointment-date">
                      {{ actionNote.createdAt }}
                    </p>
                    <p>
                      {{ `- ${actionNote.adminName} : "${actionNote.note}"` }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import { DateTime } from "luxon";
import ScButton from "@/lib/components/ScButton";

export default {
  components: {
    ScButton
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    const statusMap = {
      CREATED: "นัดใหม่",
      CANCELLED: "ยกเลิก",
      CONFIRMED: "ยืนยัน",
      WAIT_CONFIRMED_SERVICE_COMPLETE: "ยืนยัน",
      PROVIDER_FULFILLED: "ช่างปิดงาน",
      FULFILLED: "เสร็จสิ้น"
    };

    return {
      textNote: null,
      statusMap,
      appointmentNotices: null,
      appointmentsCanceled: null,
      showAppointmentRecord: true,
      showCanceledAppointmentRecord: true
    };
  },
  computed: {
    isShowAppointmentRecord() {
      return this.showAppointmentRecord;
    },
    isShowCanceledAppointmentRecord() {
      return this.showCanceledAppointmentRecord;
    },
    activeAppointmentNotice() {
      if (!this.appointmentNotices || this.appointmentNotices.length === 0) {
        return null;
      } if (this.appointmentNotices.length === 1) {
        return this.appointmentNotices[0];
      } 
        return this.appointmentNotices.reduce((a, b) => (b.id > a.id ? b : a));
      
    },
    inActiveAppointmentNotices() {
      if (!this.appointmentNotices || this.appointmentNotices.length <= 1) {
        return null;
      } 
        return this.appointmentNotices
          .filter(notice => notice.id !== this.activeAppointmentNotice.id)
          .sort((a, b) => b.id - a.id);
      
    }
  },
  created() {
    this.setupForm();
  },
  methods: {
    async fetchData() {
      try {
        const id = this.value;
        const response = await baanRueJaiClient.admin.subscriptions.appointments.getAppointmentNotices(
          id
        );

        return response.data.result;
      } catch (error) {
        return [];
      }
    },
    async setupForm() {
      const {
        current_appointment_notices: currentAppointmentNotices,
        appointment_canceled: appointmentCanceled
      } = await this.fetchData();

      this.appointmentNotices = this.setupFormAppointmentNotices(
        currentAppointmentNotices
      );
      this.appointmentsCanceled = this.setupFormAppointmentCanceled(
        appointmentCanceled
      );
    },
    setupFormAppointmentNotices(currentAppointmentNotices) {
      if (
        !currentAppointmentNotices ||
        currentAppointmentNotices.length === 0
      ) {
        return null;
      }

      const appointmentNotices = currentAppointmentNotices
        .filter(appointmentNotice => appointmentNotice.status !== "EMPTY_SLOT")
        .map(appointmentNotice => {
          const actionNotes =
            appointmentNotice.action_notes &&
            appointmentNotice.action_notes.length > 0
              ? appointmentNotice.action_notes.map(actionNote => {
                  let adminName = "Admin : ";
                  const {admin} = actionNote;

                  if (admin) {
                    const {provider} = admin;

                    if (provider) {
                      adminName = `RJ Partner (${admin.first_name} ${admin.last_name})`;
                    } else {
                      adminName = `Admin (${admin.first_name} ${admin.last_name})`;
                    }
                  }

                  const createdAt = convertDateTimeToTimeText(
                    actionNote.created_at
                  );

                  return {
                    adminName,
                    createdAt,
                    note: actionNote.note,
                    id: actionNote.id
                  };
                })
              : null;

          let actionName;
          const {admin} = appointmentNotice;
          const user = appointmentNotice.user_profile;

          if (admin) {
            const {provider} = admin;

            if (provider) {
              actionName = `RJ Partner (${admin.first_name} ${admin.last_name})`;
            } else {
              actionName = `Admin (${admin.first_name} ${admin.last_name})`;
            }
          } else if (user) {
            actionName = `App (${user.first_name} ${user.last_name})`;
          }

          return {
            id: appointmentNotice.id,
            appointmentId: appointmentNotice.appointment_id,
            status: this.statusMap[appointmentNotice.status],
            createdAt: convertDateTimeToTimeText(appointmentNotice.created_at),
            statusClassList: [appointmentNotice.status.toLowerCase()],
            actionNotes,
            isClickActiveAppointment: true,
            actionName
          };
        });

      return appointmentNotices;
    },
    setupFormAppointmentCanceled(appointmentCanceled) {
      if (!appointmentCanceled || appointmentCanceled.length === 0) {
        return null;
      }

      return appointmentCanceled.map((appointCanceled, index) => ({
          id: appointCanceled.id,
          isOpenTab: false,
          appointmentNotices: this.setupFormAppointmentNotices(
            appointCanceled.appointment_notices
          ),
          no: appointmentCanceled.length - index
        }));
    },
    async handleEnterToAddActionNote() {
      if (
        !this.textNote ||
        this.textNote === "" ||
        !this.appointmentNotices ||
        this.appointmentNotices.length === 0
      ) {
        this.$message.error("กรุณาระบุข้อความก่อนกดบันทึก");

        return;
      }

      try {
        await this.createActionNoteAppointmentNotices();
        this.$message.success("เพิ่มข้อมูลเรียบร้อย");
        this.updateActionForm();
      } catch (error) {
        this.$message.error("เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้ง");
        
      }
    },
    updateActionForm() {
      const firstName = localStorage.getItem("adminFirstName");
      const lastName = localStorage.getItem("adminLastName");
      const note = this.textNote;
      const now = convertDateTimeToTimeText(DateTime.now());

      const actionNote = [
        {
          adminName: `Admin (${firstName} ${lastName})`,
          createdAt: now,
          note,
          id: 9999999999
        }
      ];

      const activeNotice = this.appointmentNotices.reduce((a, b) =>
        b.id > a.id ? b : a
      );

      this.appointmentNotices = this.appointmentNotices.map(
        appointmentNotice => {
          let {actionNotes} = appointmentNotice;
          if (appointmentNotice.id === activeNotice.id) {
            if (appointmentNotice.actionNotes) {
              actionNotes = actionNote.concat(appointmentNotice.actionNotes);
            } else {
              actionNotes = actionNote;
            }
          }

          const isClickActiveAppointment =
            appointmentNotice.id === activeNotice.id
              ? true
              : appointmentNotice.isClickActiveAppointment;

          return {
            ...appointmentNotice,
            actionNotes,
            isClickActiveAppointment
          };
        }
      );

      this.textNote = null;
    },
    async createActionNoteAppointmentNotices() {
      const activeAppointment = this.appointmentNotices.reduce((a, b) =>
        b.id > a.id ? b : a
      );

      const params = {
        appointment_notice_id: activeAppointment.id,
        note: this.textNote
      };

      await baanRueJaiClient.admin.subscriptions.appointments.postActionNote(
        params
      );

      
    },
    handleShowActionNoteDetail(appointmentNotice) {
      const appointmentNotices = this.appointmentNotices.map(notice => ({
          ...notice,
          isClickActiveAppointment:
            appointmentNotice.id === notice.id
              ? !notice.isClickActiveAppointment
              : notice.isClickActiveAppointment
        }));

      this.appointmentNotices = appointmentNotices;
    },
    handleShowActionNoteAppointmentCanceledDetail(
      appointmentCanceled,
      appointmentNoticeCanceled
    ) {
      const appointmentsCanceled = this.appointmentsCanceled.map(
        appointCanceled => {
          const appointmentNotices =
            appointmentCanceled.id === appointCanceled.id
              ? appointCanceled.appointmentNotices.map(notice => ({
                    ...notice,
                    isClickActiveAppointment:
                      appointmentNoticeCanceled.id === notice.id
                        ? !notice.isClickActiveAppointment
                        : notice.isClickActiveAppointment
                  }))
              : appointCanceled.appointmentNotices;

          return {
            ...appointCanceled,
            appointmentNotices
          };
        }
      );

      this.appointmentsCanceled = appointmentsCanceled;
    },
    handleOpenTapCanceled(appointmentCanceled) {
      this.appointmentsCanceled = this.appointmentsCanceled.map(
        appointCanceled => ({
            ...appointCanceled,
            isOpenTab:
              appointCanceled.id === appointmentCanceled.id
                ? !appointCanceled.isOpenTab
                : appointCanceled.isOpenTab
          })
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.status {
  p {
    font-size: 16px;
    font-weight: bold;
  }

  & .created {
    color: $secondary-color;
  }

  & .cancelled {
    color: $danger-color;
  }

  & .confirmed,
  & .wait_confirmed_service_complete {
    color: $warning-color;
  }

  & .provider_fulfilled {
    color: $success-dark-color;
  }

  & .fulfilled {
    color: $success-color;
  }
}

.appointment-record-wrapper {
  width: 100%;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  overflow: hidden;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 12px 24px;

  .title {
    flex-grow: 1;
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
}

.content {
  border-top: 1px solid #e6e6e6;
}

p {
  font-size: 16px;
}

.detail {
  font-size: 16px;

  > .appointment-date {
    font-weight: bold;
  }
}

.input-note {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 16px;
}

.collapsible {
  color: rgb(3, 3, 3);
  padding-inline: 24px;
  padding-block: 16px;
  width: 100%;
  text-align: left;
  outline: none;
}

.collapsible-border {
  border-bottom: 1px solid #e6e6e6;
}

.canceled-detail {
  cursor: pointer;
  width: 100%;
  outline: none;
}

.active {
  background-color: #f7f7f7;
}

.in-active {
  background-color: rgb(253, 253, 253);
}

.arrow-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
}

.arrow {
  width: 8px;
  height: 8px;
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.canceled {
  padding: 16px 24px;
}

.button {
  width: 124px;
  height: 44px;
  font-weight: bold;
  font-size: 16px;
  border-radius: 8px;
  color: $white;
  border: none;
}
</style>
